import { render, staticRenderFns } from "./DetallePersona.vue?vue&type=template&id=456c8f95"
import script from "./DetallePersona.vue?vue&type=script&lang=js"
export * from "./DetallePersona.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports